module.exports = __webpack_public_path__ + "static/netiquette-1356ef83989ff77cbbc3564f9b9f103f.jpg";